import enLang from "./entries/en-US";

const AppLocale: any = {
  en: enLang
};

export default AppLocale;
